import React from 'react'
import loadingIcon from '/app/assets/images/insurance/icons/loader.gif'

export default function DynamicFormAndPDFViewerLoading() {
  return (
    <div style={{ position: 'sticky', top: 30, zIndex: 2 }} className="dome-full-width">
      <div className="dome-d-flex dome-justify-center">
        <div
          style={{
            width: 'fit-content',
            padding: '6px 12px',
            borderRadius: 6,
            background: 'var(--fill, #F9F9F9)',
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.10)',
          }}
          className="dome-d-flex dome-flex-column dome-align-center"
        >
          <img src={loadingIcon} width={55} height={55} alt="loading icon" />
          <span className="dome-p1 dome-color-dark-grey">preview loading...</span>
        </div>
      </div>
    </div>
  )
}
